module.exports = __webpack_public_path__ + "static/img/rec_edges_r_b.862e47d1.png";